import React, { useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ModalDialog from '../../../Components/ModalDialog';
import { create } from '../../../Redux/Action/TeamsAction';
import { isObjectEmpty } from '../../../Library/Functions';
import KeyValueEditRow from '../../../Components/KeyValueEditRow';
import { getAll } from '../../../Redux/Action/UserAction';

const initialState = {
  name: 'Montageteam',
  userIds: [],
};

function reducer(state, action) {
  switch (action.type) {
    case 'name':
      return { ...state, name: action.payload };
    case 'users': {
      const users = action.payload.monteure.filter((item) => action.payload.value.indexOf(item.userId) > -1);

      return {
        ...state,
        users: action.payload.value,
        userArray: users,
        usersDisplay: users.map((item) => (`${item.firstname} ${item.lastname}`)).join(' / '),
      };
    }
    case 'reset':
      return { ...initialState };

    default:
      throw new Error();
  }
}

/**
 * Add()
 * @param props
 * @returns {null|*}
 * @constructor
 */
function Add(props) {
  const {
    visible, onClose, onSaved, createTeam, monteureOnly, dispatchGetAllUsers,
  } = props;
  const [state, dispatch] = useReducer(reducer, initialState);
  const [errors, setErrors] = useState({});
  const [selectOptions, setSelectOptions] = useState([]);

  React.useEffect(() => {
    dispatchGetAllUsers();
  }, [dispatchGetAllUsers]);

  React.useEffect(() => {
    if (monteureOnly && monteureOnly.length > 0) {
      const options = monteureOnly.map((item) => ({
        value: item.userId,
        label: `${item.firstname} ${item.lastname}`,
      }));
      setSelectOptions(options);
    }
  }, [monteureOnly]);

  const save = () => {
    setErrors({});
    let mergedErrors = {};
    if (!state.users || state.users.length === 0) {
      mergedErrors = { ...mergedErrors, users: true };
    }
    if (state.name === '') {
      mergedErrors = { ...mergedErrors, name: true };
    }

    if (isObjectEmpty(mergedErrors)) {
      createTeam({ name: state.name, users: state.userArray }).then(() => {
        dispatch({ type: 'reset' });
        setErrors({});
        onSaved();
      });
    } else {
      setErrors(mergedErrors);
    }
  };

  const onCancel = () => {
    dispatch({ type: 'reset' });
    setErrors({});
    onClose();
  };

  return (
    <ModalDialog onClose={() => onCancel()} onConfirm={() => save()} visible={visible}>
      <div className="row">
        <div className="col-sm-12">
          <h5 className="hk-text-primary">
            Montageteam erstellen
          </h5>

          <hr />

          <KeyValueEditRow
            title="Teamname"
            type="text"
            initialValue={state.name}
            displayText={state.name}
            onChange={(value) => dispatch({ type: 'name', payload: value })}
            containerTabIndex={1}
            required
            hasError={!!(errors.name)}
          />

          <KeyValueEditRow
            title="Monteure im Team"
            type="select"
            selectData={selectOptions}
            isMultiSelect
            initialValue={state.users}
            displayText={state.usersDisplay}
            onChange={(value) => dispatch({ type: 'users', payload: { value, monteure: monteureOnly } })}
            containerTabIndex={2}
            required
            hasError={!!(errors.users)}
          />

          <small>
            Hinweis: Der als erstes ausgewählte Monteur ist innerhalb des Teams verantwortlich für die Erstellung des
            Montageberichts!
          </small>
        </div>
      </div>
    </ModalDialog>
  );
}

function mapStoreToProps(store) {
  return {
    isLoading: store.user.isLoggedin,
    monteureOnly: store.user.monteureOnly,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createTeam: (teamData) => dispatch(create(teamData)),
    dispatchGetAllUsers: () => dispatch(getAll()),
  };
}

export default connect(mapStoreToProps, mapDispatchToProps)(Add);

Add.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired,
  createTeam: PropTypes.func.isRequired,
  monteureOnly: PropTypes.instanceOf(Array),
  dispatchGetAllUsers: PropTypes.func.isRequired,
};

Add.defaultProps = {
  monteureOnly: null,
};
